import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#121212] text-gray-400 py-6 mt-12 text-sm text-center">
      <div className="flex flex-col md:flex-row justify-center space-y-2 md:space-y-0 md:space-x-6">
        <a href="/privacy-policy" className="hover:text-white transition duration-200">Privacy Policy</a>
        <a href="/terms-of-service" className="hover:text-white transition duration-200">Terms of Service</a>
        <a href="/contact" className="hover:text-white transition duration-200">Contact</a>
      </div>
      <p className="mt-4">&copy; {new Date().getFullYear()} FlowQuant. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
